module.exports = __webpack_public_path__ + "star-twilight.83c87a542c134e598969.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/star-twilight.svg
// module id = ../../../../../src/assets/img/star-twilight.svg
// module chunks = main